<template>
    <div class="table-responsive">
        <!-- <h5>All History</h5> -->
        <loader v-if="isLoading" />
        <!--<b-table-simple
            v-else
            borderless
            hover
            class="list"
            id="table-all-history"
        >
             <b-thead>
                <b-tr>
                    <b-th width="15%">Record:</b-th>
                    <b-th width="10%">Added:</b-th>
                    <b-th class="th-content">Summary:</b-th>
                    <b-th width="10%">Reference:</b-th>
                    <b-th width="10%">Provider:</b-th>
                    <b-th width="10%" class="text-nowrap">Updated By:</b-th>
                    <b-th width="5%">Invoice:</b-th>
                    <b-th width="5%"></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-for="item in list">
                    <row-communication
                        v-if="item.module === 'communication'"
                        :row="item"
                        :key="`communication${item.id}`"
                        :summary-expanded="currentExpandRowId === item.id"
                        :data-record-id="item.id"
                        referer="history"
                        @edit="editComm"
                        @delete="deleteComm"
                        @expand="updateRow"
                    />
                    <row-diagnosis
                        v-if="item.module === 'diagnosis'"
                        :row="item"
                        :key="`diagnosis${item.id}`"
                        :data-record-id="item.id"
                        @reload="getList"
                        @delete="deleteDiagnosis"
                        @edit="editDiagnosis(item)"
                        @close="closeDiagnosis(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-note
                        v-if="item.module === 'note'"
                        :row="item"
                        :key="`note${item.id}`"
                        :data-record-id="item.id"
                        @edit="editNote(item)"
                        @delete="deleteNote(item)"
                        @duplicatenote="duplicateNote(item)"
                        @edit-diagnosis="editDiagnosisFromNote"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-problem
                        v-if="item.module === 'problem'"
                        :row="item"
                        :key="`problem${item.id}`"
                        :data-record-id="item.id"
                        @delete="deleteProblem(item)"
                        @close="closeProblem(item)"
                        @edit="editProblem(item)"
                        @reload="getList"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-record
                        v-if="item.module === 'record'"
                        :row="item"
                        :key="`record${item.id}`"
                        :data-record-id="item.id"
                        @edit="editRecord"
                        @view="viewRecord"
                        @reload="getList"
                        @delete="deleteRecord"
                        @duplicate="duplicateRecord"
                        @refill="refillRecord"
                        @print="printLabel(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-diagnostic
                        v-if="item.module === 'vital'"
                        :row="item"
                        :key="`vital${item.id}`"
                        :data-record-id="item.id"
                        @edit="$refs.modalEditVital.open(item)"
                        @delete="$refs.modalDeleteVital.open(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-diagnostic
                        v-if="item.module === 'diagnostic'"
                        :row="item"
                        :key="`diagnostic${item.id}`"
                        :data-record-id="item.id"
                        @edit="$refs.modalEditDiagnostic.open(item)"
                        @delete="$refs.modalDeleteVital.open(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                </template>
                <b-tr v-if="list.length === 0">
                    <b-td colspan="8">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple> -->

        <table
            v-else
            id="table-all-history"
            class="table b-table list table-hover table-borderless"
        >
            <thead>
                <tr>
                    <th width="15%">Record:</th>
                    <th width="10%">Added:</th>
                    <th class="th-content">Summary:</th>
                    <th width="10%">Reference:</th>
                    <th width="10%">Provider:</th>
                    <th width="10%" class="text-nowrap">Updated By:</th>
                    <th width="5%">Invoice:</th>
                    <th width="5%"></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="item in list">
                    <row-communication
                        v-if="item.module === 'communication'"
                        :row="item"
                        :key="`communication${item.id}`"
                        :summary-expanded="currentExpandRowId === item.id"
                        :data-record-id="item.id"
                        referer="history"
                        @edit="editComm"
                        @delete="deleteComm"
                        @expand="updateRow"
                    />
                    <row-diagnosis
                        v-if="item.module === 'diagnosis'"
                        :row="item"
                        :key="`diagnosis${item.id}`"
                        :data-record-id="item.id"
                        @reload="getList"
                        @delete="deleteDiagnosis"
                        @edit="editDiagnosis(item)"
                        @close="closeDiagnosis(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-note
                        v-if="item.module === 'note'"
                        :row="item"
                        :key="`note${item.id}`"
                        :data-record-id="item.id"
                        @edit="editNote(item)"
                        @delete="deleteNote(item)"
                        @duplicatenote="duplicateNote(item)"
                        @edit-diagnosis="editDiagnosisFromRecord"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                        :type="'all'"
                    />
                    <row-problem
                        v-if="item.module === 'problem'"
                        :row="item"
                        :key="`problem${item.id}`"
                        :data-record-id="item.id"
                        @delete="deleteProblem(item)"
                        @close="closeProblem(item)"
                        @edit="editProblem(item)"
                        @reload="getList"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-record
                        v-if="item.module === 'record'"
                        :row="item"
                        :key="`record${item.id}`"
                        :data-record-id="item.id"
                        :isNewLabProfile="isNewLab"
                        :view-type="'ALL_HISTORY'"
                        @update-invoice-status="updateInvoiceStatus"
                        @reload="getList"
                        @edit="editRecord"
                        @view="viewRecord"
                        @expand="updateRow"
                        @delete="deleteRecord"
                        @refill="refillRecord"
                        @history="viewHistoryRecord"
                        @print="printLabel(item)"
                        @duplicate="duplicateRecord"
                        @edit-diagnosis="editDiagnosisFromRecord"
                        @decline-items="declinedItemRecord"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-diagnostic
                        v-if="item.module === 'vital'"
                        :row="item"
                        :key="`vital${item.id}`"
                        :data-record-id="item.id"
                        @edit="$refs.modalEditVital.open(item)"
                        @delete="$refs.modalDeleteVital.open(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                    <row-diagnostic
                        v-if="item.module === 'diagnostic'"
                        :row="item"
                        :key="`diagnostic${item.id}`"
                        :data-record-id="item.id"
                        @edit="$refs.modalEditDiagnostic.open(item)"
                        @delete="$refs.modalDeleteVital.open(item)"
                        @expand="updateRow"
                        :content-expanded="currentExpandRowId === item.id"
                    />
                </template>
                <tr v-if="list.length === 0">
                    <td colspan="8">
                        <i>No records available</i>
                    </td>
                </tr>
            </tbody>
        </table>
        <history-pagination
            v-if="count"
            ref="historyPagination"
            :type="'all'"
            @getList="getList"
        ></history-pagination>

        <modal-delete-vital
            ref="modalDeleteVital"
            @reload="getList"
            :patientId="patientId"
        />
        <modal-edit-diagnostic
            ref="modalEditVital"
            :is-vital="true"
            @reload="reloadParent"
            :patientId="patientId"
        />
        <modal-edit-diagnostic
            ref="modalEditDiagnostic"
            @reload="reloadParent"
            :patientId="patientId"
        />
        <modal-delete-record
            ref="modalDeleteRecord"
            @reload="getList"
            :patientId="patientId"
        />

        <modal-log-communication
            ref="modalLogCommunication"
            @onsuccess="getList"
            referer="history"
            :patientDetails="patientDetails"
        />

        <modal-delete-comm
            ref="modalDeleteComm"
            module="communication"
            title="Delete Communication"
            @onsuccess="onSuccess"
        >
            Deleting this communication will also delete the communication
            record created for the recipient.
        </modal-delete-comm>

        <modal-delete-problem
            ref="modalDeleteProblem"
            @reload="onSuccess"
            :patientId="patientId"
        />
        <modal-edit-problem
            ref="modalEditProblem"
            @reload="getList"
            :patientId="patientId"
        />

        <modal-delete-snapshot
            ref="modalDeleteDiagnosis"
            title="Delete Diagnosis"
            module="diagnosis"
            :patientId="patientId"
            @onsuccess="getList"
        >
            Are you sure you want to permanently delete this record?
        </modal-delete-snapshot>

        <modal-diagnosis
            ref="modalDiagnosis"
            @onsuccess="getList"
            :patientId="patientId"
        />

        <modal-close-diagnosis
            ref="modalCloseDiagnosis"
            @onsuccess="getList"
            :patientId="patientId"
        />
        <modal-record ref="modalRecord" @onsuccess="getList" />
        <modal-view-record ref="modalViewRecord" />
        <modal-view-history ref="modalViewHistory" />
        <SoapDelete
            v-if="isSoapEnableBeta"
            ref="modalDeleteNote"
            @reload="getList"
            @success="reloadTabCount"
        />
        <modal-delete-note
            v-else
            ref="modalDeleteNote"
            @reload="getList"
            @success="reloadTabCount"
        />

        <modal-duplicate-note
            ref="modalDuplicateNote"
            @reload="getList"
            :patientId="patientId"
        />
        <modal-cage-card ref="modalCageCard" />
        <modal-decline-item
            ref="modalDeclineItem"
            modalRef="modalDeclineItem"
            :item="invoiceItem"
            @reload="getList"
        />
    </div>
</template>
<script>
import CONSTANTS from "@/constants/history";
import Records from "@/services/records";
import History from "@/services/patient-history";
import AccountService from "@/services/account.js";

export default {
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        RowCommunication: () =>
            import("@/components/patient-communications/communication-row"),
        RowDiagnosis: () =>
            import("@/components/patient-diagnosis/diagnosis-row"),
        RowNote: () => import("@/components/medical-notes/note-row"),
        RowProblem: () => import("@/components/problems/problem-row"),
        RowDiagnostic: () =>
            import("@/components/patient-diagnostic/diagnostic-row"),
        RowRecord: () => import("@/components/medical-records/record-row"),
        ModalRecord: () => import("@/module/commons/record/create-update"),
        ModalViewRecord: () => import("@/components/medical-records/view"),
        ModalViewHistory: () => import("@/components/medical-records/history"),
        ModalDeleteRecord: () =>
            import("@/components/medical-records/record-delete-modal"),
        ModalDeleteVital: () =>
            import("@/components/vitals/vital-delete-modal"),
        ModalEditDiagnostic: () =>
            import("@/components/patient-diagnostic/diagnostic-new-modal"),
        ModalLogCommunication: () =>
            import("@/components/commons/modal-patient-log-communication"),
        ModalDeleteComm: () =>
            import("@/components/patient-snapshot/modal-delete"),
        ModalEditProblem: () =>
            import("@/components/problems/problem-save-modal"),
        ModalDeleteProblem: () =>
            import("@/components/problems/problem-delete-modal"),
        ModalDeleteSnapshot: () =>
            import("@/components/patient-snapshot/modal-delete"),
        ModalDiagnosis: () => import("@/components/commons/modal-diagnosis"),
        ModalCloseDiagnosis: () =>
            import("@/components/commons/modal-close-diagnosis"),
        ModalDeleteNote: () =>
            import("@/components/medical-notes/note-delete-modal"),
        SoapDelete: () => import("@/components/soap/soap-delete"),
        ModalDuplicateNote: () =>
            import("@/components/medical-notes/note-duplicate-modal"),
        ModalCageCard: () => import("@/module/schedule/appointment/cage-card"),
        HistoryPagination: () =>
            import(
                "@/components/patient-history-pagination/history-pagination"
            ),
        ModalDeclineItem: () =>
            import("@/components/invoice-item/item-decline-modal")
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            list: [],
            isLoading: false,
            showTheToast: false,
            selectedNote: {
                title: null,
                note: null,
                notification: { value: 0 }
            },
            meta: null,
            currentExpandRowId: null,
            isNewLab: false,
            invoiceItem: {}
        };
    },
    computed: {
        isSoapEnableBeta() {
            return this.$store.getters["soap/isSoapEnableBeta"];
        },
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        timestamp() {
            return this.row.date
                ? this._fromDateCarbon(this.row.date).toFormat("X")
                : null;
        },
        VIEWS() {
            return CONSTANTS.VIEWS;
        },
        count() {
            return this.$store.state.patient.counts;
        }
    },
    mounted() {
        this.isNewLabProfile();
        this.getList();
    },
    methods: {
        updateInvoiceStatus(recordId, invoiceResponse) {
            let row = find(this.list, { id: recordId });
            if (row?.invoice_item?.invoice) {
                row.invoice_item.invoice = {
                    ...row.invoice_item.invoice,
                    ...invoiceResponse
                };
            }
        },
        onSuccess() {
            this.$store.dispatch("patient/getHistoryCount", {
                patientId: this.patientId
            });
            this.getList();
        },
        getList(page = 1) {
            this.isLoading = true;
            let params = {
                page: page,
                perPage: this.PER_PAGE
            };

            History.getAllHistory(this.patientId, params)
                .then(response => {
                    if (response.message.code == 200) {
                        this.list = response.resources;
                    } else {
                        this.showError();
                    }
                    this.updateRow(null);
                    this.isLoading = false;
                })
                .catch(error => {
                    this.showError();
                    console.error(error);
                });
        },
        reloadParent(view) {
            this.$emit("reload", view);
        },
        updateRow(rowId) {
            this.currentExpandRowId = rowId;
        },
        showError() {
            this._message("Error : Unable to get all history list", "danger");
            this.isLoading = false;
        },
        getPatientOwnerId() {
            const { active_owners } = this.patientDetails;
            if (active_owners[0]) {
                return active_owners[0].id;
            } else {
                return null;
            }
        },
        viewRecord(record) {
            Records.showRecordDetails(record.id, record.business_id).then(
                response => {
                    if (response) {
                        this.$refs.modalViewRecord.open({
                            ...record,
                            record_resources: response
                        });
                    }
                }
            );
        },
        // TODO: Duplicate function with record-list.vue
        editRecord(record) {
            let date = this._fromDateCarbon(record.date).toSeconds();
            if (record.invoice_item && record.invoice_item.date) {
                if (
                    this._fromDateCarbon(record.invoice_item.date) <
                    this._fromDateCarbon(record.date)
                ) {
                    date = this._fromDateCarbon(
                        record.invoice_item.date
                    ).toSeconds();
                }
            }

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => {
                    Records.editRecordDetails(record.id).then(response => {
                        if (response) {
                            this.$refs.modalRecord.open({
                                ...record,
                                clientID: this.getPatientOwnerId(),
                                action: "edit",
                                module: this.MODULE.PATIENT,
                                record_resources: response,
                                patient: {
                                    id: record.patient_id
                                }
                            });
                        }
                    });
                },
                onError: message => this._message(message, "danger")
            });
        },
        // TODO: Duplicate function with record-list.vue
        duplicateRecord(record) {
            Records.duplicateRecordDetails(record.id).then(response => {
                if (response) {
                    this.$refs.modalRecord.open({
                        ...record,
                        clientID: this.getPatientOwnerId(),
                        action: "duplicate",
                        module: this.MODULE.PATIENT,
                        record_resources: response
                    });
                }
            });
        },
        declinedItemRecord(record) {
            this.invoiceItem = {
                id: record.invoice_item.id,
                item_name: record.item_name,
                invoice_item: record.invoice_item,
                total: record.invoice_item.total
            };

            let date = record.invoice_item.date
                ? this._fromDateCarbon(record.invoice_item.date).toFormat("X")
                : this._fromDateCarbon(record.create_at).toFormat("X");

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => this.$refs.modalDeclineItem.open(),
                onError: message => this._message(message, "danger")
            });
        },
        // TODO: Duplicate function with record-list.vue
        refillRecord(record) {
            const recordId = record.refill_pid ? record.refill_pid : record.id;
            Records.refillRecordDetails(recordId).then(response => {
                if (response) {
                    this.$refs.modalRecord.open({
                        ...record,
                        clientID: this.getPatientOwnerId(),
                        action: "refill",
                        module: this.MODULE.PATIENT,
                        record_resources: response
                    });
                }
            });
        },
        // TODO: Duplicate function with record-list.vue
        deleteRecord(row) {
            let date = row.date
                ? this._fromDateCarbon(row.date).toFormat("X")
                : null;

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => this.$refs.modalDeleteRecord.open(row),
                onError: message => this._message(message, "danger")
            });
        },
        // TODO: Duplicate function with record-list.vue
        printLabel(record) {
            let record_type = null;

            if (record && record.type) {
                record_type = record.type;
            }

            this.$refs.modalCageCard.open({
                action: "PRINT_LABEL",
                record_id: record.id,
                record_type: record_type
            });
        },
        editComm(row) {
            this.$refs.modalLogCommunication.open({
                action: "edit",
                record: row
            });
        },
        deleteComm(row) {
            this.$refs.modalDeleteComm.open(row.id);
        },
        closeProblem(row) {
            let params = {
                editRecord: _.clone(row),
                action: "close",
                getDetails: true
            };

            this.$refs.modalEditProblem.open(params);
        },
        editProblem(row) {
            let params = {
                editRecord: _.clone(row),
                action: "edit",
                getDetails: true
            };

            this.$refs.modalEditProblem.open(params);
        },
        deleteProblem(row) {
            this.$refs.modalDeleteProblem.open(row);
        },
        deleteDiagnosis(recordId) {
            this.$refs.modalDeleteDiagnosis.open(recordId);
        },
        editDiagnosis(record) {
            // opened_by, closed_by is manually added because
            // responses from back-end is not similar with the dedicated endpoint.
            let opened_by = null;
            let closed_by = null;
            let date_opened;
            let date_closed;

            // if not available, response returns as empty array (instead of null or empty object)
            if (!Array.isArray(record.opened_by_id_label)) {
                opened_by = {
                    id: record.opened_by_id_label.id,
                    full_name: record.opened_by_id_label.name
                };

                date_opened = this._fromDateCarbon(record.date_opened).toISO();
            }

            if (!Array.isArray(record.closed_by_id_label)) {
                closed_by = {
                    id: record.closed_by_id_label.id,
                    full_name: record.closed_by_id_label.name
                };

                date_closed = this._fromDateCarbon(record.date_closed).toISO();
            }

            this.$refs.modalDiagnosis.open({
                action: "edit",
                editRecord: {
                    ...record,
                    opened_by: opened_by,
                    closed_by: closed_by,
                    date_opened: date_opened,
                    date_closed: date_closed
                }
            });
        },
        closeDiagnosis(record) {
            this.$refs.modalCloseDiagnosis.open({
                ...record,
                date_opened: this._fromDateCarbon(record.date_opened).toISO(),
                opened_by: {
                    id: record.opened_by_id_label.id,
                    full_name: record.opened_by_id_label.name
                }
            });
        },
        editNote(row) {
            window.location.href = process.env.CI_APPS + row.ci_url;
        },
        deleteNote(row) {
            this.$refs.modalDeleteNote.open(row);
        },
        duplicateNote(row) {
            this.$refs.modalDuplicateNote.open(row);
        },
        editDiagnosisFromRecord(diagnosis) {
            let self = this;
            Records.getDiagnosisDetails(this.patientId, diagnosis.id).then(
                response => {
                    if (response.message.code === 200) {
                        self.$refs.modalDiagnosis.open({
                            action: "edit",
                            editRecord: response.resource
                        });
                    }
                }
            );
        },
        async isNewLabProfile() {
            let res = await AccountService.checkFeature("lab_profile");
            let isEnabled = res?.message?.code;

            if (isEnabled === 404) {
                this.isNewLab = true;
            }
        },
        reloadTabCount() {
            this.$emit("reload-tab-count");
        },
        viewHistoryRecord(record) {
            this.$refs.modalViewHistory.open(record);
        }
    }
};
</script>
